<template >
  <div class="dzsgl">
    <div style="background-color: white; width: 100%; display: flex; justify-content: space-between;">
      <div class="searchClass" style="display: flex; align-items: center; padding-left: 20px">
        <el-input v-model="searchForm.bookName" style="width: 200px" placeholder="请输入实验名称"></el-input>
        <el-button type="primary" @click="loadVideoList" style="margin-left: 2px">查询</el-button>
      </div>

    </div>
    <div style="background-color: white">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>

        <el-table-column
          prop="expName"
          label="实验名称"
          width="300">
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="开始时间"
          show-overflow-tooltip>
        </el-table-column>

        <el-table-column
          prop="score"
          label="得分"
          show-overflow-tooltip>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top: 10px"
        background
        @current-change="handleCurrentChange"
        layout="prev, pager, next,total"
        :current-page.sync="nowPage"
        :page-size="pageSize"
        prev-text="上一页"
        next-text="下一页"
        :total="totalCount">
      </el-pagination>
    </div>


    <div>
      <el-dialog title="信息详情" :visible.sync="dialogFormVisible">
        <el-form :model="updateForm" :rules="rules" ref="updateForm">
          <el-form-item label="分类" :label-width="formLabelWidth" prop="typeId">
            <el-select v-model="updateForm.typeId" placeholder="请选择">
              <el-option
                v-for="item in bookTypeList"
                :key="item.id"
                :label="item.typeName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标题" :label-width="formLabelWidth" prop="title">
            <el-input v-model="updateForm.title" autocomplete="off" placeholder="请输入视频标题"></el-input>
          </el-form-item>
          <el-form-item label="摘要" :label-width="formLabelWidth" prop="introduce">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入视频摘要"
              v-model="updateForm.introduce">
            </el-input>
            <!--<el-input v-model="updateForm.introduce" autocomplete="off"></el-input>-->
          </el-form-item>
          <el-form-item label="搜索关键字" :label-width="formLabelWidth" prop="keyWord">
            <el-input v-model="updateForm.keyWord" autocomplete="off" placeholder="关键字格式建议采用: 关键字1;关键字2;关键字3..."></el-input>
          </el-form-item>
          <el-form-item label="创作者" :label-width="formLabelWidth">
            <el-input v-model="updateForm.author" autocomplete="off" placeholder="请输入主讲人/导演/出品人"></el-input>
          </el-form-item>
          <el-form-item label="制作方" :label-width="formLabelWidth">
            <el-input v-model="updateForm.press" autocomplete="off" placeholder="请输入制作方名称"></el-input>
          </el-form-item>
          <el-form-item label="制作时间" :label-width="formLabelWidth">
            <el-date-picker
              v-model="updateForm.publishTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
            <!--<el-input v-model="updateForm.publishTime" autocomplete="off" ></el-input>-->
          </el-form-item>
          <el-form-item label="封面" :label-width="formLabelWidth">
            <el-upload
              class="avatar-uploader"
              :action="uploadImgUrl"
              name="imgFile"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              auto-upload
              :headers="authHeader"
              list-type="picture"
              :before-upload="beforeAvatarUpload">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="文件" :label-width="formLabelWidth">
            <el-upload
              class="upload-demo"
              auto-upload
              :headers="authHeader"
              drag
              :on-success="handleVideoSuccess"
              :before-upload="beforePdfUpload"
              :action="uploadPdfUrl"
              name="pdfFile"
              :file-list="pdfFileList"
              :on-remove="handleRemove"
              multiple
              >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传mp4文件</div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>


</template>

<script>
import { uploadImgUrl,uploadPdfUrl,getExpScoreList,updateVideoInfo,delVideoInfo,qryVideoTypeList,authToken} from '../../request/api';

export default {
  data() {
    return {
      bookTypeList:[],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      checkAll: false,
      multipleSelection: [],
      tableData: [],
      search: '',
      updateForm: {
        typeId:'',
        id:'',
        title: '',
        introduce: '',
        keyWord: '',
        author: '',
        press: '',
        publishTime: '',
        coverUrl: '',
        pdfList:[]
      },
      rules: {
        typeId:[
          { required: true, message: '分类不能为空', trigger: 'blur' },
        ],
        title: [
          { required: true, message: '书名不能为空', trigger: 'blur' },
          { max: 50, message: '长度小于50个字符', trigger: 'blur' }
        ],
        introduce: [
          { required: true, message: '书名不能为空', trigger: 'blur' },
          { max: 200, message: '长度小于200个字符', trigger: 'blur' }
        ],
        keyWord: [
          { required: true, message: '关键字不能为空', trigger: 'blur' },
          { max: 50, message: '长度小于50个字符', trigger: 'blur' }
        ]
      },
      searchForm: {
        bookName: "",
        dateRange: []
      },
      dialogFormVisible: false,
      formLabelWidth: '120px',
      nowPage: 1,
      pageSize: 10,
      totalCount: 0,
      uploadImgUrl: "",
      uploadPdfUrl: "",
      authHeader: {
        Authorization: ""
      },
      imageUrl: "",
      pdfFileList: []
    };
  },
  methods: {
    initUploadUrl() {
      let param = {}
      this.uploadImgUrl = uploadImgUrl(param);
      this.uploadPdfUrl = uploadPdfUrl(param);
      this.authHeader.Authorization = authToken();
    },
    handleRemove(file, fileList) {
      this.pdfFileList = fileList;
      if (this.pdfFileList.length === 0) {
        this.updateForm.pdfList = [];
      } else {
        let newPdfList = []
        this.updateForm.pdfList.forEach(value => {
          this.pdfFileList.forEach(value1 => {
            if (value1.name === value.name) {
              newPdfList.push(value);
            }
          });
        });
        this.updateForm.pdfList = newPdfList
      }

    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.updateForm.coverUrl = res.data.url;
    },
    handleVideoSuccess(res, file) {
      if (this.updateForm.pdfList === null) {
        this.updateForm["pdfList"] = []
      }
      res.data.type = file.raw.type;
      this.updateForm.pdfList.push(res.data)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return (isJPG || isPNG) && isLt2M;
    },
    beforePdfUpload(file) {
      const isPdf = file.type === 'video/mp4';
      if (!isPdf) {
        this.$message.error('上传文件类只能是 mp4 格式!');
      }
      const isLt200M = file.size / 1024 / 1024 < 2048;
      if (!isLt200M) {
        this.$message.error('上传文件大小不能超过 2GB!');
      }
      return isPdf;
    },
    // 加载视频列表
    loadVideoList(){
      let param = {
        nowPage: this.nowPage,
        pageSize: this.pageSize,
        title: this.searchForm.bookName,
        startDate: this.searchForm.dateRange[0],
        endDate: this.searchForm.dateRange[1]
      }
      getExpScoreList(param).then(
        resp => {
          if (resp.code === 1) {
            // 渲染数据
            this.tableData = resp.data.dataList;
            // 添加分页
            this.totalCount = resp.data.totalCount
          } else {
            this.$message.error(resp.msg);
          }
        }
      ).catch(err => {
        console.log(err)
      })
    },
    loadVideoTypeList(){
      let param = {
      }
      qryVideoTypeList(param).then(
        resp => {
          if (resp.code === 1) {
            // 渲染数据
            this.bookTypeList = resp.data;
          } else {
            this.$message.error(resp.msg);
          }
        }
      ).catch(err => {
        console.log(err)
      })
    },
    /**
     * 页码点击事件
     */
    handleCurrentChange (val) {
      // 清空之前状态
      this.tableData = []
      this.checkAll = false
      console.log('当前页：' + val)

      this.nowPage = val
      this.loadVideoList();
    },
    handleAdd() {
      this.dialogFormVisible = true;
      this.updateForm.id=''
      this.updateForm.title=''
      this.updateForm.introduce=''
      this.updateForm.keyWord=''
      this.updateForm.author=''
      this.updateForm.press=''
      this.updateForm.publishTime=""
      this.imageUrl=''
      this.updateForm.pdfList = []
      this.pdfFileList=[]
    },
    handleEdit(row) {
      this.dialogFormVisible = true;
      this.updateForm = row
      this.imageUrl = row.coverUrl
      if (row.pdfList != null) {
        this.pdfFileList = row.pdfList
      }
    },
    batchDeleteHandler(){
      let idList = []
      this.multipleSelection.forEach(function (obj, index, array) {
        idList.push(obj.id)
      });
      let param = {
        idList: idList
      }
      this.$confirm('确定删除选中记录吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log("请求:" + param)
        delVideoInfo(param).then(
          resp => {
            if (resp.code === 1) {
              this.$message({
                type: 'success',
                message: '批量删除成功!'
              });
              // 渲染数据
              this.loadVideoList();
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleDelete(row) {
      this.$confirm('确定删除选中记录吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let param = {
          idList: [row.id]
        }
        delVideoInfo(param).then(
          resp => {
            if (resp.code === 1) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              // 渲染数据
              this.loadVideoList();
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onSubmit() {

      if (this.updateForm.coverUrl === '') {
        this.$message.error('封面不能为空!');
        return
      }

      if (this.updateForm.pdfList.length === 0) {
        this.$message.error('文件不能为空!');
        return
      }

      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          console.log("文件的列表:" + this.pdfFileList)
          this.dialogFormVisible = false
          let param = this.updateForm;
          updateVideoInfo(param).then(
            resp => {
              if (resp.code === 1) {
                this.$message.success(resp.msg);
                // 重置列表
                this.loadVideoList();
              } else {
                this.$message.error(resp.msg);
              }
            }
          ).catch(err => {
            console.log(err)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleSelectionChange(val) {
      console.log("这个val是多少： " + val)
      this.multipleSelection = val;
    }
  },
  mounted() {
    // 加载书籍分类列表
    this.loadVideoTypeList();
    // 加载列表
    this.loadVideoList();
    // 加载上传组件信息
    this.initUploadUrl();
  },
  props: ["itemData"]
};
</script>

<style lang="less">
.dzsgl{
  background-color: #EFF3FF;
  padding: 20px;
  height: calc(100vh - 200px);
}
.el-table th.el-table__cell{
    background-color: #EFF3FF;
  }

  .searchClass{
    width: 900px;
    height: 70px;

  }

.searchClass .el-form-item__content {
  margin-top: 13px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
  .avatar-uploader{
    text-align: left;
  }
  .upload-demo{
    text-align: left;
  }
.dzsgl .el-table .el-table__body-wrapper{
  height: calc(100vh - 355px);
  min-height: 250px;
  overflow-y: auto;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100%;
}

.el-select {
  width: 100%;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
  padding-left: 10px;
  padding-right: 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/sp/spsgl.vue